<script>
export default {
    name: 'ServicePlanFeatureCalendahActiveCalendar',
};
</script>

<script setup>
import ServicePlanFeatureElementsMax from '@/components/payments/components/service-plan/components/features/components/elements/max.vue';

defineProps({
    feature: {
        type:     Object,
        required: true,
    },
});
</script>

<template>
    <service-plan-feature-elements-max
        :feature="feature"
        unit="active calendars"
    />
</template>
